import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

//Common
import { Snackbar } from "../../common/VFX-UI";

//App
import { OrganizationEmployeeDto } from "../../../app/model/api/types/dto";
import EmployeeForm from "../EmployeeForm";
import { OrganizationEmployeeViewModel } from "../../../viewModels";
import { OrganizationInvalidEmployeeFormContainerProps, SnackbarState } from "../../../types";
import { organizationApi } from "../../../app/model/api";
import { apiErrorMessage } from "../../../utility/lib/error";
import { queryKeys } from "./constants";

export const InvalidEmployeeFormContainer: React.FC<
OrganizationInvalidEmployeeFormContainerProps
> = (props) => {
  const { onClose, onShowSuccess, formData } = props;
  const queryClient = useQueryClient();
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const onShowErrorSnackbar = (errorMessage: string) => {
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });
  };

  const onCloseSnackbar = () => {
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });
  };

  const { status, mutate } = useMutation<void, Error, OrganizationEmployeeDto>({
    mutationFn: async (payload: OrganizationEmployeeDto) => {
      const response = await organizationApi.saveEmployee(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess("Saved Successfully.");
        await queryClient.refetchQueries({
            queryKey: [queryKeys.getInvalidEmployee],
          });
      }
    },
  });

  const handleOnSubmit = async (values: OrganizationEmployeeViewModel) => {
    const employee: OrganizationEmployeeDto = values.toDto();
    mutate(employee);
  };
  
  const initialValues = 
   new OrganizationEmployeeViewModel(
        formData?.id ?? null,
        formData?.firstName ?? null,
        formData?.lastName ?? null,
        formData?.emailAddress ?? null,
        formData?.personnelNumber ?? null,
        formData?.workPersonnelArea ?? null,
        formData?.divisionName ?? null,
        formData?.supervisorName ?? null,
        formData?.domainLanId ?? null,

        formData?.statusId !== null &&
        formData?.statusId !== undefined
          ? [formData?.statusId]
          : null,

        formData?.typeId !== null &&
        formData?.typeId !== undefined
          ? [formData?.typeId]
          : null,
        formData?.organizationUnitName ?? null,
        formData?.organization ?? null,
        formData?.mi ?? null,
        formData?.stepUpEnrollmentDate
          ? formData?.stepUpEnrollmentDate?.toString().split("T")[0]
          : null,
        formData?.leadershipEnrollmentDate
          ? formData?.leadershipEnrollmentDate?.toString().split("T")[0]
          : null,
        formData?.isActive ?? null
      );

  return (
    <>
      <EmployeeForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleOnSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
